import axiosInstance from "./AxiosInstance";

class UTDService {
  async getProducts(label) {
    const url = `/site-builder/meta-details?siteId=ac748282f6441b5ae7b1cd93c495ada7&label=${label}&limit=9999&order=priority&pageId=8519060053355805133`;

    try {
      const { data } = await axiosInstance.get(url);
      const products = data.payload.results;
      return products;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }
}

export default new UTDService();
